export default __webpack_public_path__ + "static/media/IMG_20191118_104317.0c318d60.jpg";